import * as usuarioFazendaVinculoActions from './usuarioFazendaVinculoActions';

export const INITIAL_STATE = {
  fazendasUsuario: []
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case usuarioFazendaVinculoActions.SET_FAZENDAS_USUARIO:
      return { ...state, fazendasUsuario: action.payload };

    case usuarioFazendaVinculoActions.RESET_FAZENDAS_USUARIO:
      return { ...state, fazendasUsuario: [] };

    default:
      return state;
  }
};
